import {
  DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
export function saveSupabaseDataInExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_BEGIN,
    });
    const { projectId, version, dataForSave } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/externalDb`,
        dataForSave,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
          console.log('res here supabase data', res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          const { response } = err;
          if (response.status === 400) {
            const { error } = response.data ? response.data : '';
            toast.error(`${error} !`);
          } else {
            console.log('error', err);
          }
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveSupabaseDataInExternalDbError() {
  return {
    type: DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_BEGIN:
      return {
        ...state,
        saveSupabaseDataInExternalDbPending: true,
        saveSupabaseDataInExternalDbError: null,
      };

    case DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_SUCCESS:
      return {
        ...state,
        saveSupabaseDataInExternalDbPending: false,
        saveSupabaseDataInExternalDbError: null,
        supabaseExternalData: action.data,
      };

    case DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_FAILURE:
      return {
        ...state,
        saveSupabaseDataInExternalDbPending: false,
        saveSupabaseDataInExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_SUPABASE_DATA_IN_EXTERNAL_DB_DISMISS_ERROR:
      return {
        ...state,
        saveSupabaseDataInExternalDbError: null,
      };

    default:
      return state;
  }
}
